import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Auth & roles
import PrivateRoute from './Privateroute';
import AppLayout from './AppLayout';

// Páginas públicas
import Login from './Login';

// Páginas protegidas
import CatalogoTabla from './CatalogoTabla';
import InformeCarga from './InformeCarga';
import DetalleModelo from './DetalleModelo';
import MayoresDiferencias from './MayoresDiferencias';
import UsadosTabla from './UsadosTabla';
import ComparadorModelos from './Comparadormodelos';
import AsesorAuto from './AsesorAuto';
import MisListas from './MisListas';
import DetalleLista from './DetalleLista';
import UserProfile from './UserProfile';
import Mantenedor from './Mantenedor';
import DashboardPM from './Dashboardpm';
import SimuladorPricing from './SimuladorPricing';
import InteligenciaPM from './InteligenciaPM';
import GestionLeads from './GestionLeads';
import GestionUsuarios from './Gestionusuarios';

// Componentes que siguen existiendo (sin routeKey propio, solo auth)
import HistorialConsultas from './HistorialConsultas';
import SpecsMantenedor from './SpecsMantenedor';
import SpecsDetalle from './SpecsDetalle';
import TokenFab from './TokenFab';
import AlertBell from './AlertBell';

function App() {
  return (
    <Router>
      <ToastContainer position="bottom-right" autoClose={3000} />

      <Routes>

        {/* ── Pública ───────────────────────────────────────────── */}
        <Route path="/login" element={<Login />} />

        {/* ── Rutas protegidas — Sidebar compartido en AppLayout ── */}
        <Route element={<AppLayout />}>

          <Route path="/" element={
            <PrivateRoute routeKey="catalogo"><CatalogoTabla /></PrivateRoute>
          } />
          <Route path="/modelos" element={
            <PrivateRoute routeKey="catalogo"><CatalogoTabla /></PrivateRoute>
          } />
          <Route path="/catalogo-tabla" element={
            <PrivateRoute routeKey="catalogo"><CatalogoTabla /></PrivateRoute>
          } />
          <Route path="/modelo/:id" element={
            <PrivateRoute routeKey="catalogo"><DetalleModelo /></PrivateRoute>
          } />
          <Route path="/informe-carga" element={
            <PrivateRoute routeKey="catalogo"><InformeCarga /></PrivateRoute>
          } />
          <Route path="/novedades" element={
            <PrivateRoute routeKey="novedades"><MayoresDiferencias /></PrivateRoute>
          } />
          <Route path="/diferencias" element={<Navigate to="/novedades" replace />} />

          <Route path="/usados" element={
            <PrivateRoute routeKey="usados"><UsadosTabla /></PrivateRoute>
          } />
          <Route path="/usados-tabla" element={<Navigate to="/usados" replace />} />

          <Route path="/asesor" element={
            <PrivateRoute routeKey="asesor"><AsesorAuto /></PrivateRoute>
          } />
          <Route path="/mis-listas" element={
            <PrivateRoute routeKey="listas"><MisListas /></PrivateRoute>
          } />
          <Route path="/mis-listas/:id" element={
            <PrivateRoute routeKey="listas"><DetalleLista /></PrivateRoute>
          } />
          <Route path="/perfil" element={
            <PrivateRoute routeKey="perfil"><UserProfile /></PrivateRoute>
          } />

          <Route path="/inteligencia" element={
            <PrivateRoute routeKey="inteligencia"><InteligenciaPM /></PrivateRoute>
          } />
          <Route path="/inteligencia/:tab" element={
            <PrivateRoute routeKey="inteligencia"><InteligenciaPM /></PrivateRoute>
          } />

          <Route path="/admin/mantenedor" element={
            <PrivateRoute routeKey="mantenedor"><Mantenedor /></PrivateRoute>
          } />
          <Route path="/admin/usuarios" element={
            <PrivateRoute routeKey="usuarios"><GestionUsuarios /></PrivateRoute>
          } />

          {/* Car IA se fusionó con Asesor IA en un solo asistente con selector de perspectiva */}
          <Route path="/ia" element={<Navigate to="/asesor" replace />} />
          <Route path="/historial" element={
            <PrivateRoute><HistorialConsultas /></PrivateRoute>
          } />
          <Route path="/admin/specs" element={
            <PrivateRoute><SpecsMantenedor /></PrivateRoute>
          } />
          <Route path="/admin/specs-detalle" element={
            <PrivateRoute><SpecsDetalle /></PrivateRoute>
          } />

        </Route>

        {/* ── 404 → raíz ───────────────────────────────────────── */}
        <Route path="*" element={<Navigate to="/" replace />} />

      </Routes>

      <TokenFab />
      <AlertBell />
    </Router>
  );
}

export default App;